<!-- Only load the application outside of iframes to prevent problems with MSAL -->
@if (!isIframe) {
<div class="main-container">
  <app-sidebar (sidebarToggle)="onSidebarToggle($event)"></app-sidebar>
  <div class="content" [ngClass]="{'content-expanded': isSidebarOpen}">    
    <router-outlet></router-outlet>
  </div>
</div>
}
